import { AfterViewInit, Component, OnInit, ChangeDetectorRef, OnDestroy, HostListener, ElementRef, ViewChild, Input } from '@angular/core';
import { ApiService } from '@services/api.service';
import { UiHelper } from '@helpers/ui.helper';

import { BehaviorSubject, from, Observable, of, Subject, Subscription } from 'rxjs';
import { DataHelper } from '@helpers/data.helper';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { LocalizationService } from '@services/localization.service';
import { TranslateService } from '@services/translate.service';
import { UserHelper } from '@helpers/user.helper';
import { debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs/operators';
import { Location } from '@angular/common';
import { debounce } from 'lodash';
import { SignalrServiceLegacy } from '@services/signalr.service.legacy';
import { WebWorkerService } from '../modules/workers/web-worker.service';
import { FormControl, Validators } from '@angular/forms';
import { environment } from '@environments/environment';
import { AppTimerService } from '@services/app-timer.service';
import { sportsSvgList } from '@app/constants/svgUrl.constant';
import { LiveStreamService } from '@services/liveStream.service';
import { OddModel } from '@app/models/odd.model';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
@Component({
  selector: 'best-live-desktop-component',
  templateUrl: '../sharedTemplates/best-live-desktop.component.html',
  providers: [AppTimerService],
})
export class BestLiveDesktopComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('storySliderBox') storySliderBox: ElementRef;
  public sportsSvgList = sportsSvgList;
  _dayFilter = 300;
  selectedSportId = -2;
  selectedLeagueData = [];
  seeMore = false;
  whichPart = '';
  translateSize = null;
  isMobileView = false;
  isMySlipButton = false;

  public openReSend: (() => void) & { cancel: () => void };

  subscription: Subscription;
  searchKeySubject = new Subject<any>();
  showSearchResults = false;
  filled = true;
  searchValue = new FormControl('');
  constructor(
    public _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _ApiService: ApiService,
    public _DataHelper: DataHelper,
    public _Router: Router,
    private _ActivatedRoute: ActivatedRoute,
    private _LocalizationService: LocalizationService,
    private _TranslateService: TranslateService,
    public _LZ: LocalizationService,
    private cdRef: ChangeDetectorRef,
    private _SignalRService: SignalrServiceLegacy,
    private _webWorkerService: WebWorkerService,
    private _location: Location,
    private _TimerService: AppTimerService,
    private _LiveStreamService: LiveStreamService,
    private router: Router
  ) {
    if (this._DataHelper.LeagueData !== undefined) {
      this.sportName = this._DataHelper.LeagueData[0].SportName;
      this.countryName = this._DataHelper.LeagueData[0].CategoryName;
      this.leagueName = this._DataHelper.LeagueData[0].TournamentName;
      this.sportId = this._DataHelper.LeagueData[0].SportId;
    }

    const urlPopular = this._Router.url.indexOf('/popular');
    const urlHighlights = this._Router.url.indexOf('/highlights');
    const urlLastminute = this._Router.url.indexOf('/lastminute');
    const urlEvents = this._Router.url.indexOf('/events');
    this.urlFavs = this._Router.url.indexOf('/favorites');

    if (urlPopular > -1) {
      this.urlIsPopular = true;
      this.liveIsActive = false;
    }
    if (this.urlFavs > -1) {
      this.openFavPreMatches();
    }

    this._Router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const url = event.url.split('/');
        if (url && url.length > 0 && url[1] === 'fav') {
          this.urlFavs = 1;
          this.openFavPreMatches();
        } else {
          if (this.urlFavs !== -1) {
            this.urlFavs = -1;
          }
        }
      }
    });

    if (urlHighlights > -1 || urlLastminute > -1 || urlEvents > -1) {
      this.liveIsActive = false;
    }

    if (this._Router.url.indexOf('/search') > -1) {
      this._UiHelper.setSportInputStatus(true);
    } else {
      this._UiHelper.setSportInputStatus(false);
    }

    // BURAYI KONTROL ET

    this.subscriptionsToStopOnDestroy.push(
      this._DataHelper.searchDataListener.subscribe(x => {
        if (x) {
          this.changeSearch(true);
          const a = this.getFavorableStates(x);
          this.preMatchList = a;
          this._DataHelper.preMatchobservable.next(this.preMatchList);
        }
      })
    );

    let isBelowGivenWidth = this._UiHelper.windowsWidth < 990;
    this._UiHelper.windowResized.subscribe(x => {
      if (x.w >= 990) {
        if (isBelowGivenWidth) {
          this.tournamentSelectionState(1);
        }
      } else {
        isBelowGivenWidth = true;
      }
    });

    this.searchEventSubject
      .pipe(debounceTime(500))
      .pipe(distinctUntilChanged())
      .subscribe(x => {
        this.flagSearch = true;
        this.getSearchp1001(x);
        this.changeSearch(false);
      });
    this.openReSend = debounce(
      () => {
        this._ApiService
          .getResendConfirmationMail()
          .then((x: any) => {
            this._UiHelper.successSnackBar(this._TranslateService.instant('Resend_Mail_Success_Text'), '');
          })
          .catch(() => {
            this._UiHelper.errorSnackBar(this._TranslateService.instant('help_mail_error'), '');
          });
      },
      30000, // The delay time.
      { leading: true, trailing: true }
    );
    this._UiHelper.windowsWidth < 990 ? (this.isMobileView = true) : (this.isMobileView = false);
  }
  searchInput = '';

  searchInputObj = {
    group: 1,
    fname: 'username',
    type: 'input_text_username',
    FType: 'input_text',
    value: '',
    placeholder: 'Search',
    hint: '',
    errText: '',
    isActive: true,
    validators: [Validators.minLength(3)],
    key: 'fieldusername',
  };

  urlFavs = -1;
  tournamentFavourited = false;

  searchEventSubject = new Subject();

  sportName = '';
  countryName = '';
  leagueName = '';
  sportId = 1;

  preMatchList = [];
  mainData = [];

  homeSliderData = [];
  contentHeight;
  othersHeight;
  favPreMatchobservable = new BehaviorSubject<any>([]);
  LeagueData: Array<any>;
  _selectedOdds: OddModel[] = [];
  oddMarketingValue = [0];

  oddMarketingp1001Value = [0, 4, 3, 5];

  _catId = '0';

  isResult = false;

  panLeft = '0';

  // Live Parts
  liveMatchList = [];
  oldLiveMatchList = [];
  cardList = [];
  __ResultLiveData;
  fullmatch: Observable<any[]>;
  isInitialized = false;

  urlIsPopular = false;
  liveIsActive = true;

  private subscriptionsToStopOnDestroy: Subscription[] = [];

  isOpenLeagueMenu = true;
  isOpenSportsMenu = true;

  // [0,2,3];
  oddComboList: Array<OddComboModel> = [
    {
      OddId: 0,
      OddNameLong: 'tipp_long',
      OddName: 'tipp',
      OddTitles: ['1', 'X', '2'],
    },
    {
      OddId: 1,
      OddNameLong: 'handicap',
      OddName: 'hc',
      OddTitles: ['', '1', 'X', '2'],
    },
    {
      OddId: 2,
      OddNameLong: 'O/U_long',
      OddName: 'O/U',
      OddTitles: ['', '+', '-'],
    },
    {
      OddId: 3,
      OddNameLong: 'DoppelteChance',
      OddName: 'DC',
      OddTitles: ['1X', '12', 'X2'],
    },
    {
      OddId: 4,
      OddNameLong: 'Treffenbeide?',
      OddName: 'TF?',
      OddTitles: ['Y', 'N'],
    },
    {
      OddId: 5,
      OddNameLong: 'NextGoal',
      OddName: 'NT',
      OddTitles: ['1', 'X', '2'],
    },
    {
      OddId: 6,
      OddNameLong: 'HTFirstHalf',
      OddName: 'TIPP 1.HZ',
      OddTitles: ['1', 'X', '2'],
    },
    {
      OddId: 7,
      OddNameLong: 'Ü/U 1.HZ_long',
      OddName: 'Ü/U 1.HZ',
      OddTitles: ['', '+', '-'],
    },
  ];

  combo1SelectedOdd = this.oddComboList.find(combo => combo.OddId == 0);
  combo2SelectedOdd = this.oddComboList.find(combo => combo.OddId == 4);
  combo3SelectedOdd = this.oddComboList.find(combo => combo.OddId == 3);
  combo4SelectedOdd = this.oddComboList.find(combo => combo.OddId == 5);

  basepreMatchList;
  currentActiveTimeFilter = 0;

  tournamentSelection = {
    page: 1,
    page1InsideSelection: 'total',
    isTournamentSelection: false,
    tournamentName: '',
    tournamentId: 0,
    data: {
      seasonName: '',
      year: '',
      seasonStandings: [],
      last6SummaryStats: [],
    },
  };
  tournamentSelectionp1001 = {
    page: 1,
    page1InsideSelection: 'total',
    isTournamentSelection: false,
    tournamentName: '',
    tournamentId: 0,
    tournamentBetradarId: 0,
    SportId: 0,
    CategoryId: 0,
    data: [],
  };
  resendMailButtonState = true;
  flagSearch = false;
  @HostListener('window:resize', ['$event'])
  onResize() {
    this._UiHelper.setResolution(window.innerWidth, window.innerHeight);
  }

  ngOnInit() {
    this.subscriptionsToStopOnDestroy.push(
      this._ActivatedRoute.params.subscribe(p => {
        if (p['q'] == 0) {
          this.changeSearch(false, true);
        }

        if (p['q'] != undefined && p['q'] != null && this._DataHelper.searchData != undefined) {
          this.getSearchp1001(p['q']);
        }

        if (p['q'] != undefined && p['q'] != null && this._DataHelper.searchData == undefined) {
          this._DataHelper.setSearchDataViaUrl(p['q']);
        }
      })
    );

    this.subscriptionsToStopOnDestroy.push(
      this._ActivatedRoute.queryParams.subscribe(p => {
        if (p['TimeRangeId'] != undefined && p['TimeRangeId'] != null) {
          this._DataHelper.leftMenuSportDayFilter = p['TimeRangeId'];
        }

        if (p['MenuId'] != undefined && p['MenuId'] != null) {
          this._catId = p['MenuId'];
        }
        this.getSelectedFixture();
      })
    );
    this.subscriptionsToStopOnDestroy.push(
      this._ActivatedRoute.params.subscribe(p => {
        if (p['MenuId'] != undefined && p['MenuId'] != null) {
          this._DataHelper.leftMenuSportDayFilter = p['TimeRangeId'];
        }

        if (p['TimeRangeId'] != undefined && p['TimeRangeId'] != null) {
          this._catId = p['MenuId'];
        }
        this.getSelectedFixture();
      })
    );
    this._DataHelper.setFavListListener.subscribe(() => {
      if (this.urlFavs !== -1) {
        this.openFavPreMatches();
      }
    });
    this.subscription = this.searchValue.valueChanges
      .pipe(
        debounceTime(500), // Kullanıcının yazmayı bırakmasının ardından 500ms bekler
        distinctUntilChanged(), // Sadece farklı arama terimleri için çalışır
        switchMap(term => {
          return from(this.getSearch(term)); // Promiseyi observable'a dönüştürür
        })
      )
      .subscribe(
        results => {
          this._DataHelper.setSearchData(results);
        },
        error => console.log('err', error)
      );
    this.getSports();
  }

  ngAfterViewInit() {
    this._UiHelper.setNavbarTitle('', null, false);
    this.heightsetter(this._UiHelper.windowsHeight);
    this.subscriptionsToStopOnDestroy.push(
      this._UiHelper.windowResized.subscribe(x => {
        this.heightsetter(x.h);
      })
    );

    this.subscriptionsToStopOnDestroy.push(
      this._UiHelper.contentHeightListener.subscribe(x => {
        this.othersHeight = x;
      })
    );

    // Daha önce seçilen oddları tekrar seçsin
    this.subscriptionsToStopOnDestroy.push(
      this._ApiService.selectedOddsEvent.subscribe(x => {
        this._selectedOdds = x as OddModel[];
      })
    );
    this._ApiService.getSelectedOdds();

    // p1001 de Mobil de çalışmıyor. Routing den dolayı. Desktop ta çalışıyor
    // Sports Filter Control
    this.subscriptionsToStopOnDestroy.push(
      this._DataHelper.LeagueDataListener.subscribe(x => {
        if (x.TeamId) {
          this.getSelectedMyTeamFixture(x.TeamId);
        } else {
          this.getFixture();
        }
        // Filter değişince listeyi değiştir
      })
    );

    // Live : If connection is not exists
    if (!this._SignalRService.connectionExists) {
      this.subscriptionsToStopOnDestroy.push(
        this._SignalRService.connectionEstablished.subscribe(x => {
          // //////console.log("canlı bağlandı detayda : ", x);
          this.connectHub();
        })
      );
    } else {
      this.connectHub();
    }
  }

  getRouterLink(): string[] {
    return ['/account/verifications'];
  }

  getSelectedFixture() {
    if (this._Router.url.indexOf('/popular') > -1) {
      this._DataHelper.LeagueData = undefined;
      this.getPopularFixture('-1');
    } else if (this._Router.url.indexOf('/highlights') > -1) {
      this._DataHelper.LeagueData = undefined;
      this.getPopularFixture('-2');
    } else if (this._Router.url.indexOf('/home') > -1) {
      this._DataHelper.LeagueData = undefined;
      // 11-05-2022 --  N2-316 daki maddeye göre getPopularFixture veya getFixture arasında tercih yap
      // this.getFixture();
      this.getPopularFixture('-2');
    } else if (this._Router.url.indexOf('/lastminute') > -1) {
      this._DataHelper.LeagueData = undefined;
      this.getPopularFixture('-3');
    } else if (this._Router.url.indexOf('/events') > -1) {
      this._DataHelper.LeagueData = undefined;
      this.getPopularFixture('-4');
    } else if (this._Router.url.indexOf('/allevents') > -1) {
      this._DataHelper.LeagueData = undefined;
      this.getPopularFixture('-15');
    } else if (this._Router.url.indexOf('/search') > -1) {
      //// console.log('YYES',this._Router.url.indexOf('/0'));
      this._DataHelper.LeagueData = undefined;
      this.getPopularFixture('-1');
      if (this._Router.url.indexOf('/0') > -1) {
        this.changeSearch(false, true);
      }
    } else if (this._Router.url.indexOf('/league') > -1) {
      const selectedLeagueData = [];

      this.subscriptionsToStopOnDestroy.push(
        this._ActivatedRoute.queryParams.subscribe(p => {
          if (p['CatId'] != undefined && p['CatId'] != null) {
            const cbData = {
              TournamentName: '',
              TournamentId: p['TourId'],
              CategoryId: p['CatId'],
              CategoryName: '',
              SportId: 1,
              SportName: 'Soccer',
            };

            selectedLeagueData.push(cbData);
            this._DataHelper.leftMenuSportDayFilter = 300;
            this._DataHelper.setLeagueData(selectedLeagueData);
          }
        })
      );

      this.getPopularFixture('-4');
    } else {
      if (this.urlFavs < 0) {
        this.getFixture();
      }
    }
  }

  heightsetter(c) {
    this.contentHeight = c - this.othersHeight;
    this.contentHeight += 'px';
  }

  changeSearch(v, ui?) {
    this.isResult = v;
    ui ? this.getFixture() : null;
  }

  getFavorableStates(_x) {
    const a = this._UserHelper.favoriedMatches;
    return _x.map(y => {
      // //////console.log(a, y.BetradarMatchId);
      if (a == null) {
        return y;
      }
      if (a.includes(y.BetradarMatchId)) {
        y['favorableState'] = true;
        return y;
      } else {
        y['favorableState'] = false;
        return y;
      }
    });
  }

  getFixture() {
    this._UiHelper.setLoadingDialog(true);
    this._ApiService
      .getFixture()
      .then(x => {
        x = this.getFavorableStates(x);
        this.preMatchList = x;

        this._DataHelper.preMatchobservable.next(this.preMatchList);
        this.changeSearch(false);
        this._UiHelper.setLoadingDialog(false);

        const tournamentsArray = new Set(this.preMatchList.map(i => i.BetradarTournamentId));
        this.tournamentSelectionp1001.isTournamentSelection = tournamentsArray.size === 1;

        this.tournamentSelection.isTournamentSelection = tournamentsArray.size === 1;
        if (this.preMatchList && this.preMatchList.length > 0) {
          try {
            this.tournamentSelection.tournamentName = this.preMatchList[0].TournamentNameShort;
            this.tournamentSelection.tournamentId = this.preMatchList[0].BetradarTournamentId;

            this.tournamentSelectionp1001.SportId = this.preMatchList[0].SportId;
            this.tournamentSelectionp1001.tournamentId = this.preMatchList[0].TournamentId;
            this.tournamentSelectionp1001.tournamentBetradarId = this.preMatchList[0].BetradarTournamentId;
          } catch (e) {
            console.log('sports', e);
          }
        }

        if (this.tournamentSelectionp1001.isTournamentSelection) {
          // this.getTournamentStatistic();
          this.getTournamentStatisticp1001();
        }

        this.dataRebuild();

        this.cdRef.detectChanges();
        if (this._UiHelper.leftMenu) {
          this._UiHelper.setLeftMenu();
        }
        this._TimerService.setTimer('scrollToTop', () => this._UiHelper.ScrollToTop(), 100);
      })
      .catch(err => console.log('sports', err));
  }

  getPopularFixture(_sId) {
    this._UiHelper.setLoadingDialog(true);
    this._ApiService
      .getFixture(_sId, this._catId)
      .then(x => {
        this.preMatchList = x;
        this._DataHelper.preMatchobservable.next(this.preMatchList);
        this.changeSearch(false);

        if (this._UiHelper.leftMenu) {
          this._UiHelper.setLeftMenu();
        }

        this._UiHelper.setLoadingDialog(false);
      })
      .catch(err => console.log('sports', err));
  }

  getFavs() {
    this._ApiService.getSearch4Favs().then(x => {
      x = this.getFavorableStates(x);
      this.favPreMatchobservable.next(x);
      this.cdRef.detectChanges();
    });
  }

  connectHub() {
    this.subscriptionsToStopOnDestroy.push(
      this._DataHelper.liveDataListener.subscribe(y => {
        this.oldLiveMatchList = this.liveMatchList;
        this.liveMatchList = y;
        this.cdRef.detectChanges();
        this.dataRebuild();
      })
    );

    this.liveMatchList = this._DataHelper.liveData;
    this.oldLiveMatchList = this.liveMatchList;

    // Card
    this.cardList = this._DataHelper.cardData;
    this.subscriptionsToStopOnDestroy.push(
      this._DataHelper.cardDataListener.subscribe(y => {
        this.cardList = y;
      })
    );
    // Card

    this.dataRebuild();
    this.cdRef.detectChanges();

    // this._SignalRService.readUpdatedEvents();
  }

  dataRebuild() {
    if (this._DataHelper.LeagueData == undefined) {
      return;
    }
    const isMySlipLive = environment.isMySlipLive;

    const wwsConfig = {
      isMySlipEnvironment: isMySlipLive,
      isMySlipButton: this._DataHelper.isMySlipButton,
      mySlipMatchList: this._DataHelper.mySlipMatchList,
      langCode: this._LocalizationService.LANGCODE,
      lml: this.liveMatchList,
      old_lml: this.oldLiveMatchList,
      cardList: this.cardList,
      oddtype: [0],
      favorable: this._UserHelper.favoriedMatches,
      lfd: this._DataHelper.LeagueData,
      isLive: false,
      liveSortbyTime: false,
    };

    this._DataHelper.webWorkerLiveJob(wwsConfig);

    const promise = this._webWorkerService.run(this._DataHelper.webWorkerLiveJob, wwsConfig).then(result => {
      this.__ResultLiveData = result.dt;

      const Obsobj = of(this.__ResultLiveData);
      this.fullmatch = Obsobj;

      this.isInitialized = true;
      this.cdRef.detectChanges();
    });
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptionsToStopOnDestroy) {
      if (subscription) {
        subscription.unsubscribe();
      }
    }
    this.openReSend.cancel();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  toggleLeagueMenu() {
    this.isOpenLeagueMenu = !this.isOpenLeagueMenu;
  }

  toggleSportsMenu() {
    this.isOpenSportsMenu = !this.isOpenSportsMenu;
  }

  oddComboChange(oddMarket, index) {
    const newOddMarket: number[] = Array.from(this.oddMarketingp1001Value);
    newOddMarket[index] = oddMarket.OddId;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.oddMarketingp1001Value = newOddMarket;

    const x = this.getFavorableStates(this.preMatchList);
    this.preMatchList = x;
    this._DataHelper.preMatchobservable.next(this.preMatchList);
  }

  oddBoxClick(oddMarket, index) {
    this.combo1SelectedOdd = oddMarket;

    const newOddMarket: number[] = Array.from(this.oddMarketingp1001Value);
    newOddMarket[index] = oddMarket.OddId;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.oddMarketingp1001Value = newOddMarket;

    const x = this.getFavorableStates(this.preMatchList);
    this.preMatchList = x;
    this._DataHelper.preMatchobservable.next(this.preMatchList);
  }

  favRoute() {
    this._Router.navigate(['/favorites']);
  }

  openFavPreMatches() {
    this.preMatchList = this._DataHelper.favFixtureList;
    this._DataHelper.preMatchobservable.next(this.preMatchList);
    this.dataRebuild();
  }

  timeFilterChanged(e) {
    this._DataHelper.leftMenuSportDayFilter = e;
    if (this.selectedSportId == -2) {
      if (e === '300') {
        // All hightlight fixture kontrolü
        this.getPopularFixture('-2');
      } else {
        this.getFixture();
      }
    } else {
      this._ApiService.getFixture(this.selectedSportId.toString(), '0').then(x => {
        this.preMatchList = x;
        this._DataHelper.preMatchobservable.next(this.preMatchList);
      });
    }
  }

  getSports(__dayFilter = 300) {
    if (this._DataHelper.homeMainData == undefined || this._DataHelper.homeMainData.length == 0) {
      this._ApiService.getSports(__dayFilter).then(x => {
        this.mainData = x.map(x => {
          x['level'] = [];
          x['loading'] = false;
          x['state'] = false;
          return x;
        });
        this._DataHelper.homeMainData = this.mainData;
      });
    } else {
      this.mainData = this._DataHelper.homeMainData;
    }
    setTimeout(() => {
      this.isSeeMore();
    }, 1000);
  }
  isSeeMore() {
    const dataLength = this._DataHelper.homeMainData.length;
    const widthBox = this.storySliderBox?.nativeElement?.offsetWidth;
    if (widthBox) {
      const listWidth = (dataLength + 2) * 80;
      if (dataLength > 0) {
        if (widthBox < listWidth) {
          this.whichPart = 'first';
          if (listWidth / 2 > widthBox) {
            this.seeMore = true;
            this.translateSize = 200;
          } else {
            this.seeMore = true;
            this.translateSize = listWidth - widthBox;
          }
        } else {
          this.seeMore = false;
          this.translateSize = 0;
        }
      }
    }
  }
  goLeft() {
    if (this.storySliderBox) {
      this.storySliderBox.nativeElement.scroll({ left: this.storySliderBox.nativeElement.scrollLeft - this.translateSize, behavior: 'smooth' });
      if (this.storySliderBox.nativeElement.scrollLeft - this.translateSize < 1) {
        this.whichPart = 'first';
      } else {
        this.whichPart = '';
      }
    }
  }
  goRight() {
    if (this.storySliderBox) {
      this.storySliderBox.nativeElement.scroll({ left: this.storySliderBox.nativeElement.scrollLeft + this.translateSize, behavior: 'smooth' });
      if (this.translateSize === 200) {
        if (this.storySliderBox.nativeElement.scrollLeft >= this._DataHelper.homeMainData.length * 80 - 2 * this.translateSize - 30) {
          this.whichPart = 'last';
        } else {
          this.whichPart = '';
        }
      } else {
        this.whichPart = 'last';
      }
    }
  }
  mySlipButtonAction(): void {
    this._DataHelper.isMySlipButton = true;
    this.router.navigate(['/live']);
  }

  onClickAllEvent(sportId) {
    this.selectedLeagueData = [];
    this.selectedSportId = sportId;
    if (this._DataHelper.selectedStorySportAllItem) {
      this._DataHelper.LeagueData = undefined;
      this._ApiService.getFixture(this.selectedSportId.toString(), '0').then(x => {
        this.preMatchList = x;
        this._DataHelper.preMatchobservable.next(this.preMatchList);
      });
    }
  }

  add2TournamentFavs() {
    if (this._DataHelper.LeagueData[0] === undefined) {
      return;
    }
    // console.log(this._DataHelper.LeagueData);
    const favitem = {
      tourid: this._DataHelper.LeagueData[0].TournamentId,
      tourname: this._DataHelper.LeagueData[0].TournamentName,
      catid: this._DataHelper.LeagueData[0].CategoryId,
      catname: this._DataHelper.LeagueData[0].CategoryName,
      count: this.preMatchList.length,
    };
    this._UiHelper.favTournamentChanged(favitem);
    this.tournamentFavourited = !this.tournamentFavourited;
  }

  getTournamentStatisticp1001() {
    this._ApiService
      .getTournamentStatisticp1001(this.tournamentSelectionp1001.SportId, this.tournamentSelectionp1001.CategoryId, this.tournamentSelectionp1001.tournamentId)
      .then(x => {
        this.tournamentSelectionp1001.data = x;
        this.tournamentSelectionp1001.isTournamentSelection = true;
      });
  }
  goAccountTab() {
    this.router.navigate(['/account/credit']);
    if (this._UiHelper.isMobileView) {
      this._UiHelper.SetRightMenuState('close');
    }
  }

  getFormTableDataTranslate(data) {
    if (typeof data == 'string') {
      const dataArray = [];

      data
        .split('-')
        .map(item => {
          dataArray.push(item);

          return this._TranslateService.instant(`${item}`, null);
        })
        .toString()
        .replace(/,/g, '-');
      return dataArray;
    }
    return '';
  }
  tournamentStatsPage1(whichState: string): void {
    this.tournamentSelection.page1InsideSelection = whichState;
    this.tournamentSelection.page = 1;

    //
    this.tournamentSelectionp1001.page1InsideSelection = whichState;
    this.tournamentSelectionp1001.page = 1;
  }

  tournamentSelectionState(whichState: number): void {
    this.tournamentSelection.page = whichState;
    this.tournamentSelection.page1InsideSelection = 'total';

    ///
    this.tournamentSelectionp1001.page = whichState;
    this.tournamentSelectionp1001.page1InsideSelection = 'total';
  }
  searchInputChange(e) {
    if (e.length >= 3 && !this.flagSearch) {
      this.searchEventSubject.next(e);
    }
  }
  getSearchp1001(e) {
    this._ApiService
      .getSearchp1001(e)
      .then(x => {
        // console.warn('SEARCH', x);
        this._DataHelper.setSearchData(x);
        // this._Router.navigate(['search', e]);
        this.flagSearch = false;
      })
      .catch(err => console.log('err', err));
  }
  getSearch(term: string) {
    this._UiHelper.searchTerm = term;

    if (term && term.length > 3) {
      return this._ApiService
        .getSearchp1001(term)
        .then(x => {
          this._DataHelper.setSearchData(x);
          if (x && x.length === 0) {
            this._UiHelper.hasSearchData = false;
          } else {
            this._UiHelper.hasSearchData = true;
          }
        })
        .catch(err => console.log('err', err));
    } else if (term == '') {
      const searchKey = 'All';
      return this._ApiService
        .getSearchp1001(searchKey)
        .then(x => {
          this._DataHelper.setSearchData(x);
          if (x && x.length === 0) {
            this._UiHelper.hasSearchData = false;
          } else {
            this._UiHelper.hasSearchData = true;
          }
        })
        .catch(err => console.log('err', err));
    } else {
      //Observable hatası almamak için manuel boş array atandı, 3 harften küçükse

      this._DataHelper.setSearchData([]);

      this._UiHelper.hasSearchData = false;
      return [];
    }
  }

  openSearchBar() {
    // this.showSearchResults = true;
    this._UiHelper.setSportInputStatus(true);
    this._DataHelper.preMatchobservable.next([]);
    this.onSearchClick();
    this.getSearch(this.searchValue.value);
  }
  onSearchClick() {
    this.searchKeySubject.next();
  }

  // closeSearchBar() {
  //   this.showSearchResults = false;
  //   this.searchValue.setValue('');
  // }
  // clickOutside(event: any) {
  //   if (event && event.targetElement.id != 'searchMenu' && !event.clickInside ) {
  //     this.showSearchResults = false;

  //   }
  // }
  onInputChange(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const searchTerm = inputElement.value;
    this.searchValue.setValue(searchTerm);
  }

  goBack() {
    this._location.back();
  }

  // todo deleted
  goToLink(e: string) {
    try {
      if (e.includes('http')) {
        window.location.href = e;
      } else {
        if (e.charAt(0) != '/') {
          window.location.href = window.location.origin + '/' + e;
        } else {
          window.location.href = window.location.origin + e;
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  getResponsiveOddShow(indexOddOrder) {
    switch (indexOddOrder) {
      case 1:
        return this._UiHelper.isResponsiveRules(['s']);
      case 2:
        return this._UiHelper.isResponsiveRules(['xl']);
      case 3:
        return this._UiHelper.isResponsiveRules(['xxl']);
      default:
        return true;
    }
  }
  getSelectedMyTeamFixture(teamId) {
    this._UiHelper.setLoadingDialog(true);
    let sID = '0';
    let cID = '-1';
    let tID = '0';

    if (teamId === -1) {
      sID = '0';
      cID = '-2';
      tID = this._UserHelper.customerUser.CustomerId;
    } else {
      sID = '0';
      cID = '-1';
      tID = teamId;
    }
    this._ApiService
      .getFixture(sID, cID, tID)
      .then(x => {
        x = this.getFavorableStates(x);
        this.preMatchList = x;

        this._DataHelper.preMatchobservable.next(this.preMatchList);
        this.changeSearch(false);
        this._UiHelper.setLoadingDialog(false);

        const tournamentsArray = new Set(this.preMatchList.map(i => i.BetradarTournamentId));
        this.tournamentSelectionp1001.isTournamentSelection = tournamentsArray.size === 1;

        this.tournamentSelection.isTournamentSelection = tournamentsArray.size === 1;
        if (this.preMatchList && this.preMatchList.length > 0) {
          try {
            this.tournamentSelection.tournamentName = this.preMatchList[0].TournamentNameShort;
            this.tournamentSelection.tournamentId = this.preMatchList[0].BetradarTournamentId;

            this.tournamentSelectionp1001.SportId = this.preMatchList[0].SportId;
            this.tournamentSelectionp1001.tournamentId = this.preMatchList[0].TournamentId;
            this.tournamentSelectionp1001.tournamentBetradarId = this.preMatchList[0].BetradarTournamentId;
          } catch (e) {
            console.log('sports', e);
          }
        }

        if (this.tournamentSelectionp1001.isTournamentSelection) {
          // this.getTournamentStatistic();
          this.getTournamentStatisticp1001();
        }

        this.dataRebuild();

        this.cdRef.detectChanges();
        if (this._UiHelper.leftMenu) {
          this._UiHelper.setLeftMenu();
        }
        this._TimerService.setTimer('scrollToTop-2', () => this._UiHelper.ScrollToTop(), 100);
      })
      .catch(err => console.log('sports', err));
  }
}

export class OddComboModel {
  constructor(OddId: number, OddName: string, OddNameLong: string, OddTitles: []) {
    this.OddId = OddId;
    this.OddName = OddName;
    this.OddTitles = OddTitles;
    this.OddNameLong = OddNameLong;
  }

  OddId: number;
  OddName: string;
  OddTitles: string[];
  OddNameLong: string;
}
